import React from "react";
import PageShell from "../components/PageShell";
import QuoteForm from "../components/QuoteForm";

export default function OrcamentoPage() {
  return (
    <PageShell testId="page-orcamento">
      <QuoteForm />
    </PageShell>
  );
}
